module.exports = __webpack_public_path__ + "static/media/talnesis.aa8f04b3.png";